import React from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import { format, parseISO, isValid } from 'date-fns';

const WorkloadTrendChart = ({ data, height = 60 }) => {
  if (!data || data.length === 0) {
    return (
      <div className="text-xs text-muted-foreground text-center py-2">
        No trend data available
      </div>
    );
  }

  const chartData = data.map(entry => {
    let shortDate = 'N/A';
    try {
      const parsedDate = parseISO(entry.date);
      if (isValid(parsedDate)) {
        shortDate = format(parsedDate, 'EEE');
      }
    } catch (e) {
      // Keep default
    }
    return {
      date: entry.date,
      shortDate,
      active: entry.total_active || 0,
      completed: entry.completed_tasks || 0
    };
  });

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length > 0) {
      const dataPoint = payload[0]?.payload;
      let displayDate = 'N/A';
      
      if (dataPoint?.date) {
        try {
          const parsedDate = parseISO(dataPoint.date);
          if (isValid(parsedDate)) {
            displayDate = format(parsedDate, 'MMM d');
          }
        } catch (e) {
          displayDate = dataPoint.date;
        }
      }
      
      return (
        <div className="bg-popover border rounded-lg shadow-lg p-2 text-xs">
          <p className="font-medium">{displayDate}</p>
          <p className="text-blue-500">Active: {payload[0]?.value || 0}</p>
          <p className="text-emerald-500">Completed: {payload[1]?.value || 0}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="w-full" style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={chartData} margin={{ top: 5, right: 5, bottom: 0, left: 0 }}>
          <XAxis 
            dataKey="shortDate" 
            tick={{ fontSize: 10, fill: 'var(--muted-foreground)' }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis hide />
          <Tooltip content={<CustomTooltip />} />
          <Line 
            type="monotone" 
            dataKey="active" 
            stroke="#3b82f6" 
            strokeWidth={2}
            dot={false}
            activeDot={{ r: 3, fill: '#3b82f6' }}
          />
          <Line 
            type="monotone" 
            dataKey="completed" 
            stroke="#10b981" 
            strokeWidth={2}
            dot={false}
            activeDot={{ r: 3, fill: '#10b981' }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default WorkloadTrendChart;
